
<div v-if="item.labels && item.labels.length">
  <div class="d-flex flex-wrap justify-content-left">
    <div v-for="label in sortedLabels" :key="label.id">
      <div
        class="mr-2 mb-1 d-flex justify-content-between align-items-center"
        :class="{ 'bi-label': !isEditable }"
        :style="{
          'background-color': label.color,
          color: 'white',
          padding: '1px 3px',
          'border-radius': '3px',
        }"
        @click="selectLabel(label, $event)"
      >
        <i v-if="label.icon" :class="label.icon" class="mr-1 ml-1"></i>
        {{ label.title }}
        <div v-if="isEditable">
          <i class="pr-1 ml-2 fas fa-times cursor-pointer" @click="removeLabel(label.id)"></i>
        </div>
      </div>
    </div>
  </div>
</div>
